import { FormsMultilineInput } from '@platform/components';
import { Control, FieldValues, Path } from 'react-hook-form';

export const UnresponsiveUpdateContent = <T extends FieldValues>({
  name,
  control,
}: {
  name: Path<T>;
  control: Control<T>;
}) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px] text-xl'>
      <p className='text-center '>
        Thanks for the update. We're sorry to hear there's been no response. Our MovingWorlds team
        will follow up to help move things forward.
      </p>
      <p className='text-center '>
        If you have any details to share, like when you last reached out or other helpful context,
        please add them below.
      </p>
      <div className='mt-4 items-stretch'>
        <FormsMultilineInput
          control={control}
          name={name}
          characterCount={500}
          placeholder='Anything else you want to tell us...'
        />
      </div>
    </div>
  );
};
